import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import PlaybackCloud from "../../Utils/Custom/VideoDoorWebRTC/PlaybackCloud";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
interface Props {
  url: string;
  deviceName: string;
  from: string;
  to: string;
  innerWidth: number;
  innerHeight: number;
  timeZoneOffset: string; //TODO: alocity change but need to verify the usecase
}

interface PublicVideoSelected {
  show: boolean;
  publicUrl: string;
  deviceName: string;
  fromDate: string;
  toDate: string;
  innerWidth: number;
  innerHeight: number;
  timeZone: string;
}

const PUBLIC_VIDEO_INIT = {
  show: false,
  publicUrl: "",
  deviceName: "",
  fromDate: "",
  toDate: "",
  innerWidth: 1300,
  innerHeight: 800,
  timeZone: "",
};

export default function ShowPublicPlaylistVideoLegacy({
  url,
  deviceName,
  from,
  to,
  innerWidth,
  innerHeight,
  timeZoneOffset,
}: Props) {
  const { t } = useTranslation();
  const [show, setShow] = useState(true);
  const [openPublicVideoSelected, setOpenPublicVideoSelected] = useState<PublicVideoSelected>({
    ...PUBLIC_VIDEO_INIT,
  });

  const openVideoCall = () => {
    setShow(true);
  };

  const urlWasUpdated = () => {
    if (!url) {
      return;
    }
    setOpenPublicVideoSelected({
      ...PUBLIC_VIDEO_INIT,
      show: true,
      publicUrl: url,
      deviceName: deviceName,
      fromDate: from,
      toDate: to,
      innerWidth: innerWidth,
      innerHeight: innerHeight,
      timeZone: timeZoneOffset,
    });
  };

  useEffect(urlWasUpdated, [url]);

  return (
    <Grid
      container
      justify="center"
      style={{ width: "100%" }}
      data-testid="show-public-playlist-video"
    >
      <Grid container justify="center">
        <img
          src={"/images/designed/anavio.svg"}
          alt="Anavio logo"
          style={{ objectFit: "cover", width: "15%", marginTop: "8px" }}
        />
      </Grid>
      <Button
        style={{ marginTop: "16px" }}
        variant="contained"
        color="primary"
        onClick={openVideoCall}
      >
        {t("OpenVideo")}
      </Button>
      <Grid item xs={12}>
        {show && openPublicVideoSelected.publicUrl && (
          <PlaybackCloud
            serialNumber={"public"}
            deviceName={openPublicVideoSelected.deviceName}
            startDateTime={openPublicVideoSelected.fromDate + "Z"}
            endDateTime={openPublicVideoSelected.toDate + "Z"}
            // onNoVideo={() => setAwsVideoNotFound(true)}
            onClose={() => {
              setShow(false);
            }}
            showEvents={false}
            publicUrl={openPublicVideoSelected.publicUrl}
            isPublic={true}
            customHeightProp={openPublicVideoSelected.innerHeight}
            customWidthProp={openPublicVideoSelected.innerWidth}
            timeZoneOffset={openPublicVideoSelected.timeZone}
          />
        )}
      </Grid>
    </Grid>
  );
}
